<script>
import MainLayout from '../layouts/mainLayout'
import {DateUtil} from '@/utils/date.js'
import dialog from '@/components/Dialog'
export default {
  components: {MainLayout, 'v-dialog': dialog},
  beforeMount () {
    let shiftId = this.$route.query.shiftId

    this.$axios.get('shift/queryShiftInfoDetail', {params: {shiftId: shiftId}})
      .then(response => {
        this.shiftInfo = response.data.shiftInfo
        this.shiftInfo.useTime = this.shiftInfo.moveShiftTime
        this.shiftInfo.moveShiftTime = DateUtil.yearWeek(this.shiftInfo.moveShiftTime)
        this.personLeftNumber = 3 - this.shiftInfo.rePassengerNumber
        let shiftPasspoints = this.shiftInfo.shiftPasspoints
        let sps = []
        if (shiftPasspoints.length !== 0) {
          // 添加起始S
          sps.push(
            {
              index: 'S',
              estimateTime: shiftPasspoints[0].startEstimateTime !== null ? shiftPasspoints[0].startEstimateTime : this.shiftInfo.startEstimateTimeSlot,
              name: shiftPasspoints[0].stationName,
              address: shiftPasspoints[0].address,
              actualTime: shiftPasspoints[0].arriveActualTime,
              stopFlag: true,
              routeType: shiftPasspoints[0].routeType,
              stationId: shiftPasspoints[0].stationId,
              stationLat: shiftPasspoints[0].stationLat,
              stationLng: shiftPasspoints[0].stationLng,
              passengerNameKana: '',
              reserveId: '',
              arrivePassengers: []
            }
          )
          // 一般情况
          let index = -1
          let houseIndex = 0
          let gIndex = 0
          for (let shiftPasspoint of shiftPasspoints) {
            index++
            if (index === 0) continue
            let spindex = ''
            if (index === shiftPasspoints.length - 1) {
              spindex = 'G'
            } else if (shiftPasspoint.routeType === '0') {
              spindex = 'G' + (++gIndex)
            } else {
              spindex = '' + (++houseIndex)
            }

            let name = ''
            let nameKana = ''
            let addressObj = null
            let stopFlag = false
            let arrivePassengers = []
            if (shiftPasspoint.routeType === '1') {
              let nameObj = this.getPassengerNameObj(shiftPasspoint.reserveId)
              name = nameObj.name
              nameKana = nameObj.nameKana
              addressObj = this.getPassengerAddressObj(shiftPasspoint.reserveId)
              stopFlag = true
            } else {
              name = shiftPasspoint.stationName
              addressObj = {address: shiftPasspoint.address, stationId: shiftPasspoint.stationId, lat: shiftPasspoint.stationLat, lng: shiftPasspoint.stationLng}
              let stopObj = this.isStop(shiftPasspoint.stationId)
              stopFlag = stopObj.stopFlag
              arrivePassengers = stopObj.arrivePassengers
            }
            if (index === shiftPasspoints.length - 1) {
              stopFlag = true
            }
            sps.push(
              {
                index: spindex,
                estimateTime: shiftPasspoint.arriveEstimateTime !== null ? shiftPasspoint.arriveEstimateTime : this.shiftInfo.arriveEstimateTimeSlot,
                name: name,
                address: addressObj.address,
                actualTime: shiftPasspoint.arriveActualTime,
                stopFlag: stopFlag,
                routeType: shiftPasspoint.routeType,
                stationId: addressObj.stationId,
                stationLat: addressObj.lat,
                stationLng: addressObj.lng,
                passengerNameKana: nameKana,
                reserveId: shiftPasspoint.reserveId,
                arrivePassengers: arrivePassengers
              }
            )
          }
        }
        this.shiftPasspoints = sps
        // 存入Session中
        sessionStorage.setItem('shiftDetail', JSON.stringify({shiftInfo: this.shiftInfo, shiftPasspoints: this.shiftPasspoints}))
      })
      .catch(error => {
        console.log(error)
      })
      // 接続便があるか確認し、あるなら増便禁止
      this.$axios.get('shift/isEnableAddShift', {params: {shiftId: this.shift.shiftId}})
      .then(response => {
        console.log("isEnableAddShift")
        console.log(response.data)
        this.enableAddShift = response.data.shiftAddFlg
      })
  },
  mounted () {
    this.$axios.get('shift/selectInfoName').then(response => {
      sessionStorage.setItem('userInfo', JSON.stringify(response.data.userInfo))
    })
  },

  data () {
    return {
      isCheckedList: [],
      toCheckList: [],
      shift: {
        title: {type: String, default: ''},
        shiftId: {type: String, default: ''},
        driverNameKana: {type: String, default: ''},
        vehicleType: {type: String, default: ''},
        vehicleId: {type: String, default: ''},
        passengerNumber: {type: Number, default: 0},
        driverName: {type: String, default: ''},
        moveShiftTime: {type: String, default: ''},
        startPlace: {type: String, default: ''},
        startTime: {type: String, default: ''},
        arrivePlace: {type: String, default: ''},
        arriveTime: {type: String, default: ''}
      },
      shiftReservation: {
        flag: 'add'
      },
      time: {},
      isCheckedDisplay: false,
      toCheckDisplay: false,
      // dialog
      showDialog: false,
      dialogOption: {
        showNo: true,
        text: 'この予約はキャンセル待ちとなります<br/>予約を続けますか?',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      shiftInfo: {
        shiftReservationInfos: [],
        shiftPasspoints: [
          {
            startEstimateTime: '',
            stationName: '',
            address: '',
            arriveActualTime: ''
          }
        ],
        useTime: ''
      },
      personLeftNumber: null,
      shiftPasspoints: [],
      shiftMovementStatus: [
        '運行前',
        '運行中',
        '終了'
      ],
      enableAddShift: true,
      allConnectShiftsCanEdit: true
    }
  },
  created: function () {
    this.shift = JSON.parse(sessionStorage.getItem('shift'))
    this.$axios.get('shift/queryReservationStatusByShiftId', {params: {shiftId: this.shift.shiftId}})
      .then(response => {
        let list = response.data.shiftReservationInfoList
        // 已结确认状态的
        let isCheckedList = list.filter(item => (item.status === 1))
        // 待确认状态
        let toCheckList = list.filter(item => (item.status === 2))
        if (isCheckedList.length && isCheckedList.length > 0) {
          this.isCheckedDisplay = !this.isCheckedDisplay
        }
        this.isCheckedList = isCheckedList
        if (toCheckList.length && toCheckList.length > 0) {
          this.toCheckDisplay = !this.toCheckDisplay
        }
        this.toCheckList = toCheckList
        sessionStorage.setItem('toCheckList', JSON.stringify(toCheckList))
      })
      .catch(error => {
        console.log(error)
      })
      
    // 予約禁止処理　業務開始or終了なら予約禁止
    console.log("予約禁止処理")
    console.log(this.shift)
    let parentShiftId
    if(this.shift.parentShiftId == '' || this.shift.parentShiftId == null){
      parentShiftId = this.shift.shiftId
    }else{
      parentShiftId = this.shift.parentShiftId
    }
    console.log(parentShiftId)

    // 接続便一覧を取得
    this.$axios.get('shift/queryShiftInfoListByParentShiftId', {params: {parentShiftId: parentShiftId}}).then(response => {
      let shiftInfoList
      console.log("queryShiftInfoListByParentShiftId")
      console.log(response.data.shiftInfoList)
      shiftInfoList = response.data.shiftInfoList
      for (let shiftInfoTemp of shiftInfoList) {
        // 接続便の状態チェック
        if(shiftInfoTemp.businessStatus == 2){
          console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務開始」です")
          this.allConnectShiftsCanEdit = false
        }else if(shiftInfoTemp.businessStatus == 3){
          console.log(shiftInfoTemp.shiftId + " " + shiftInfoTemp.title + " の状態は「業務終了」です")
          this.allConnectShiftsCanEdit = false
        }
      }
    })
  },
  methods: {
    // 转化受信時間 将yyyyMMddHHmm转化为 yyyy/mm/dd HH:mm
    convertDate (date) {
      return DateUtil.yearMonthDayandTime(date)
    },
    // 预约详细
    reserveDetail (shiftReservationInfo) {
      this.$axios.get('shift/selectShiftReservation', {params: {reserveId: shiftReservationInfo.reserveId}})
        .then(response => {
          this.shiftReservation = response.data.shiftReservation
          this.time.reserveTime = DateUtil.yearHourMinute(this.shiftReservation.reserveTime)
          this.time.useTime = DateUtil.yearWeek(this.shiftReservation.useTime)
          this.time.startEstimateTime = DateUtil.hourMinute(this.shiftReservation.startEstimateTime)
          this.time.arriveEstimateTime = DateUtil.hourMinute(this.shiftReservation.arriveEstimateTime)
          this.shiftReservation.time = this.time
          this.shiftReservation.flag = 'edit'
          sessionStorage.setItem('shiftReservation', JSON.stringify(this.shiftReservation))
          this.$router.push({
            path: '/passengerReservationDetail',
            name: 'passengerReservationDetail',
            query: {title: '運行便に戻る'}
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    // 乘客预约按钮
    passengerReservation () {
      let isCheckedListLength = this.isCheckedList.length
      // 供DriverScheduleList判断ShiftMovementStatus使用
      sessionStorage.setItem('isCheckedListLength', isCheckedListLength)
      if (JSON.parse(sessionStorage.getItem('shiftReservation')) != null) {
        this.shiftReservation = JSON.parse(sessionStorage.getItem('shiftReservation'))
      }
      this.shiftReservation.flag = 'add'
      sessionStorage.setItem('shiftReservation', JSON.stringify(this.shiftReservation))
      if (this.shiftInfo.rePassengerNumber < this.shiftInfo.passengerNumber) {
        this.$router.push({
          path: '/passengerReservation',
          name: 'passengerReservation'
        })
      }
      // isCheckedListLength < 3
      this.showDialog = true
      this.$refs.dialog.confirm().then(() => {
        this.showDialog = false
        this.$router.push({
          path: '/passengerReservation',
          name: 'passengerReservation'
        })
      }).catch(() => {
        this.showDialog = false
      })
    },
    goback () {
      // this.$router.go(-1)
      this.$router.push({name: 'MovementShift', query: {currentDate: this.shift.moveShiftTime.substring(0, 6)}})
    },
    //
    getPassengerAddressObj (reserveId) {
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        if (reservation.reserveId === reserveId) {
          if (this.shiftInfo.shiftFlag === 0) {
            switch (reservation.startPlaceType) {
              case 1:
                return {address: reservation.homeAddress, stationId: '', lat: reservation.homeLat, lng: reservation.homeLng}
              case 2:
                return {address: reservation.startStationAddress, stationId: reservation.startStationId, lat: reservation.startStationLat, lng: reservation.startStationLng}
              default:
                return {address: reservation.startPlaceName, stationId: '', lat: reservation.startPlaceLat, lng: reservation.startPlaceLng}
            }
          } else {
            switch (reservation.arrivePlaceType) {
              case 1:
                return {address: reservation.homeAddress, stationId: '', lat: reservation.homeLat, lng: reservation.homeLng}
              case 2:

                return {address: reservation.arriveStationAddress, stationId: reservation.arriveStationId, lat: reservation.arriveStationLat, lng: reservation.arriveStationLng}
              default:
                return {address: reservation.arrivePlaceName, stationId: reservation.startStationId, lat: reservation.arrivePlaceLat, lng: reservation.arrivePlaceLng}
            }
          }
        }
      }
      return null
    },
    getPassengerNameObj (reserveId) {
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        if (reservation.reserveId === reserveId) {
          return {name: reservation.lastName + ' ' + reservation.firstName, nameKana: reservation.lastNameKana + ' ' + reservation.firstNameKana}
        }
      }
      return null
    },
    isStop (stationId) {
      let arrivePassengers = []
      let stopFlag = false
      for (let reservation of this.shiftInfo.shiftReservationInfos) {
        if (reservation.startStationId === stationId || reservation.arriveStationId === stationId) {
          arrivePassengers.push({reserveId: reservation.reserveId, name: reservation.lastName + reservation.firstName})
          stopFlag = true
        }
      }
      return {stopFlag: stopFlag, arrivePassengers: arrivePassengers}
    },
    // shiftReservation.startPlaceType==1
    startPlaceName (shiftReservationInfo) {
      if (shiftReservationInfo.startPlaceType === 1) {
        return '自宅'
      } else {
        // 地图选点
        if (shiftReservationInfo.startPlaceType === 3) {
          return shiftReservationInfo.startPlaceName
        } else {
          // 停留所
          return shiftReservationInfo.startStationName
        }
      }
    },
    // shiftReservation.arrivePlaceType==1
    arrivePlaceName (shiftReservationInfo) {
      if (shiftReservationInfo.arrivePlaceType === 1) {
        return '自宅'
      } else {
        // 地图选点
        if (shiftReservationInfo.arrivePlaceType === 3) {
          return shiftReservationInfo.arrivePlaceName
        } else {
          // 停留所
          return shiftReservationInfo.arriveStationName
        }
      }
    },
    // moveShiftTime处理
    MMdd (date) {
      return DateUtil.yMd2M_d_W(date)
    },
    // 增便
    addShift () {
      this.$router.push({ name: 'ShiftAdd' })
    }
  }

}
</script>

<template>
  <main-layout>
    <div class="col-md-12 column" style="width:100%">
      <div class="row clearfix" style="flex:0 0 40px;position: relative; height:100px">
        <div style="position: absolute;width: 100%;">
          <strong class="name-strong F3-M-27" style="line-height:100px">予約状況</strong>
        </div>
        <div class="col-md-2 column headerleft F1-R-19" style="vertical-align: bottom;">
          <input type="button" value="運行便一覧に戻る" @click="goback()" />
        </div>
      </div>
      <div class="row clearfix info bgc1" style="margin-right:43px">
        <div class="col-md-3 column leftDate">
          <!-- <span style="height:50px" class="F2-R-19">
            {{MMdd(shift.moveShiftTime)}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{shift.startTime}}発&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{shift.arriveTime}}着
          </span> -->
          <div class="flexReserveTime">
            <span class="F2-R-19" style="display: block;">{{MMdd(shift.moveShiftTime)}}</span>
            <span class="F2-R-19" style="display: block;">|</span>
            <span class="F2-R-19" style="display: block;">{{shift.startTime}}発</span>
            <span class="F2-R-19" style="display: block;">|</span>
            <span class="F2-R-19" style="display: block;">{{shift.arriveTime}}着</span>
          </div>
        </div>
        <div class="col-md-1 column middleNumber F2-R-16">
          {{shift.shiftId}}
        </div>
        <div class="col-md-8 column rightTitle F2-R-19">
          {{shift.title}}
        </div>
      </div>
      <div class="table-header" id="tableheader">
        <table>
          <thead>
            <tr class="theader F2-R-15 bgc9">
              <!-- 受付日時、氏名、フリガナ、乗車場所、下車場所-->
              <td class="trborder reservation-time htd">受付日時</td>
              <td class="trborder reservation-userName htd">氏名</td>
              <td class="trborder reservation-userNameKana htd">フリガナ</td>
              <td class="trborder reservation-startPlace htd">乗車場所</td>
              <td class="trborder reservation-arrivePlace htd">降車場所</td>
              <td class="trborder reservation-detail htd"></td>
            </tr>
          </thead>
        </table>
      </div>

      <div class="col-md-12 column" style="display:flex;flex-direction: column;height:500px;">
        <div class="table-container" style="margin-left:0px;margin-right:0px;">
          <div class="table-body scrollbar">
            <!-- 确定预约列表 -->
            <table class="table" style="border-collapse:separate; border-spacing:0px 0px;border:1px solid rgb(150,150,150)" v-show="isCheckedDisplay">
              <caption v-show="isCheckedDisplay" class="bgc1 F2-M-16">予約確定</caption>
              <tbody>
                <tr class="contenttr" v-for='(shiftReservationInfo, index) in isCheckedList' v-bind:key="shiftReservationInfo.reserveId">
                  <td class="trborder bodytext reservation-time">
                    <div class="flexReserveTime">
                      <span class="F3-R-19" style="display: block;">{{ index + 1 }}</span>
                      <span class="F3-R-15" style="display: block;">{{convertDate(shiftReservationInfo.reserveTime).substring(0,11)}}</span>
                      <span class="F3-R-15" style="display: block;">{{convertDate(shiftReservationInfo.reserveTime).substring(11,16)}}</span>
                    </div>
                  </td>
                  <td class="trborder bodytext reservation-userName F3-M-18 member-name" :title="shiftReservationInfo.userName">
                    {{ shiftReservationInfo.userName  }}
                  </td>
                  <td class="trborder bodytext reservation-userNameKana F3-M-18 member-name" :title="shiftReservationInfo.userNameKana">
                    {{ shiftReservationInfo.userNameKana }}
                  </td>
                  <td class="trborder bodytext reservation-startPlace F3-M-18 member-name" :title="startPlaceName (shiftReservationInfo)">
                    {{startPlaceName (shiftReservationInfo) }}
                  </td>
                  <td class="trborder bodytext reservation-arrivePlace F3-M-18 member-name" :title="arrivePlaceName (shiftReservationInfo)">
                    {{ arrivePlaceName (shiftReservationInfo) }}
                  </td>
                  <td class="trborder bodytext reservation-detail">
                    <button class="orderbtn F2-M-15 detailed-button" @click="reserveDetail(shiftReservationInfo)">詳細</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 待处理列表 -->
            <table class="table" style="border-collapse:separate; border-spacing:0px 0px;border:1px solid rgb(150,150,150)" v-show="toCheckDisplay">
              <caption v-show="toCheckDisplay" class="bgc1 F2-M-16">キャンセル待ち</caption>
              <tbody>
                <tr class="contenttr" v-for='(shiftReservationInfo, index) in toCheckList' v-bind:key="shiftReservationInfo.reserveId">
                  <td class="trborder1 bodytext reservation-time bgc2">
                    <div class="flexReserveTime">
                      <span class="F3-R-19" style="display: block;">{{ index + 1 }}</span>
                      <span class="F3-R-15" style="display: block;">{{convertDate(shiftReservationInfo.reserveTime).substring(0,11)}}</span>
                      <span class="F3-R-15" style="display: block;">{{convertDate(shiftReservationInfo.reserveTime).substring(11,16)}}</span>
                    </div>
                  </td>
                  <td class="trborder1 bodytext reservation-userName bgc2 F3-M-18">
                    {{ shiftReservationInfo.userName }}
                  </td>
                  <td class="trborder1 bodytext reservation-userNameKana bgc2 F3-M-18">
                    {{ shiftReservationInfo.userNameKana }}
                  </td>
                  <td class="trborder1 bodytext reservation-startPlace bgc2 F3-M-18">
                    {{startPlaceName(shiftReservationInfo)}}
                  </td>
                  <td class="trborder1 bodytext reservation-arrivePlace bgc2 F3-M-18">
                    {{arrivePlaceName (shiftReservationInfo)}}
                  </td>
                  <td class="trborder1 bodytext reservation-detail bgc2" align="center" valign="middle">
                    <button class="orderbtn F2-M-15 detailed-button" @click="reserveDetail(shiftReservationInfo)">詳細</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!--button：乘客预约，增便登录-->
    <div>
      <div class="row clearfix" v-show="shift.businessStatus===1 && allConnectShiftsCanEdit" style="width: 50%; margin:50px auto 0 auto; display:flex;">
        <a class="" @click="passengerReservation" data-toggle="modal" style="width: 100%">
            <button class="window-button1 footButton" style="width: 90%;max-width:350px;border:0px">乗客予約</button>
        </a>
        <div class="" v-show="enableAddShift&&(shift.transportKind == 0)" style="width: 100%">
          <button class="window-button1 footButton" style="width: 90%;max-width:350px;border:0px" @click="addShift">増便登録</button>
        </div>
      </div>
    </div>
    <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
  </main-layout>
</template>

<style lang="scss" scoped>
@import "../../assets/css/C00.css";
.name-strong {
  line-height:100px;
  font-size: 30px;
}

.user-btn {
  width: 200px
}

.headerleft {
  margin-left:13px;
  margin-top:30px;
  width: 300px;
  background: url(../../assets/button/back_button.png) no-repeat 10px center;
}

.headerleft input {
  float: left;
  border: none;
  background: none;
  line-height: 40px;
  width: 100%;
  text-align: left;
  text-indent: 30px;
  // font-size: 60px;
}
.headermiddle {
  margin-top: 20px;
  margin-left: 40px;
  height: 50px;
  line-height: 50px;
  font-size: 24px;
}

.info{
  background-color: rgb(150, 150, 150);
  margin-left: 15px;
  margin-right: 40px;
  height: 50px
}
.info>div {
  color: white;
  line-height: 50px;
  font-size: 18px;
  height: 50px;
}

.leftDate {
text-align: center
}
.middleNumber {
  text-align: center;
  border-left: 1px solid rgb(195, 215, 230);
}
.rightTitle {
  text-align: left;
  border-left: 1px solid rgb(195, 215, 230);
}

#tableheader {
  padding-right:10px;
  padding:0 19px;
  margin-left:-4px;
  margin-top:10px;
  margin-bottom:-15px;
  margin-right:8px
}
.flexReserveTime {
  display: flex;
  justify-content: space-between;
}

caption{
  text-align: center;
  font-size: 18px;
  color: white;
}

tbody .trborder{
  line-height: 30px;
  height: 30px;
  background-color: white;
}
tbody .trborder1{
  line-height: 30px;
  height: 30px;
  background-color: rgb(230, 230, 230)
}

.bodytext{
  font-size: 14px;
  padding-left: 15px;
  text-align: left;
}

.window-button1{
  width: 60%;
  // height: 50px;
  border-radius: 10px;
  // margin-top: -80px;
  margin-top: 20px;
  // margin-bottom: 30px;
  font-size: 2em;
  color: #fff;
  background-color: #717171;
  }
  .orderbtn {
    height: 30px;
    width: 100%;
    font-size: 16px;
    border: none;
    background: #b2b2b2;
    border-radius: 4px;
  }
  .table>tbody>tr>td{
    border:0.1px solid rgb(150, 150, 150);
    padding-top: 13px;
  }
  .htd{
    padding: 5px;
  }
  .reservation-time{
    width:12%;
  }
  .reservation-userName{
    width:12%;
  }
  .reservation-userNameKana{
    width:16%;
  }
  .reservation-startPlace{
    width:26%;
  }
  .reservation-arrivePlace{
    width:27%;
  }
  .reservation-detail{
    width:7%;
  }
   @media screen and (max-device-width: 1480px) {
   .bodytext {
     font-size: 10px;
   }
 }
 .member-name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/router/views/ReservationStatus.vue